<template lang="pug">
.container.mt-4.mt-sm-5.mb-6
    h1.mb-4 Protokoll erstellen

    .card.shadow-sm
        .card-header
            ul.nav.nav-tabs.card-header-tabs
                li.nav-item(v-if="tabAvailable(0)")
                    a.nav-link(:class="tabActive(0)", @click.prevent="activeTab = 0")
                        font-awesome-icon.mr-1(icon="home")
                        span.d-none.d-sm-inline Angaben zum Objekt

                li.nav-item(v-if="tabAvailable(1)")
                    a.nav-link(:class="tabActive(1)", @click.prevent="activeTab = 1")
                        font-awesome-icon.mr-1(icon="square-root-alt")
                        span.d-none.d-sm-inline Kennwert ermitteln

                li.nav-item(v-if="tabAvailable(2)")
                    a.nav-link(:class="tabActive(2)", @click.prevent="activeTab = 2")
                        font-awesome-icon.mr-1(icon="cube")
                        span.d-none.d-sm-inline Ist-Zustand erfassen

                li.nav-item(v-if="tabAvailable(3)")
                    a.nav-link(:class="tabActive(3)", @click.prevent="activeTab = 3")
                        font-awesome-icon.mr-1.text-success(v-if="reachedSchutzziel1", icon="check-circle")
                        font-awesome-icon.mr-1.text-warning(v-else, icon="exclamation-circle")
                        span.d-none.d-sm-inline Schutzziel 1

                li.nav-item(v-if="tabAvailable(4)")
                    a.nav-link(:class="tabActive(4)", @click.prevent="activeTab = 4")
                        font-awesome-icon.mr-1.text-success(v-if="reachedSchutzziel2", icon="check-circle")
                        font-awesome-icon.mr-1.text-warning(v-else, icon="exclamation-circle")
                        span.d-none.d-sm-inline Schutzziel 2

                li.nav-item(v-if="tabAvailable(5)")
                    a.nav-link(:class="tabActive(5)", @click.prevent="activeTab = 5")
                        font-awesome-icon.mr-1(icon="file-export")
                        span.d-none.d-sm-inline Fertigstellen

        .tab-content
            tab-metadata(v-if="tabAvailable(0)", :class="tabActive(0)", v-model="protocol", @save="saveAndContinue")
            //- tab-metadata(:class="{ active: tab === 0 }", v-model="protocol", @save="saveAndContinue")

            tab-base-values(v-if="tabAvailable(1)", :class="tabActive(1)", v-model="protocol", @save="saveAndContinue")

            tab-rooms(v-if="tabAvailable(2)", :class="tabActive(2)", v-model="protocol", @save="saveAndContinue")

            tab-schutzziel-1(
                v-if="tabAvailable(3)",
                :class="tabActive(3)",
                v-model="protocol",
                @save="saveAndContinue",
                @update="reachedSchutzziel1 = $event"
            )

            tab-schutzziel-2(
                v-if="tabAvailable(4)",
                :class="tabActive(4)",
                v-model="protocol",
                @save="saveAndContinue",
                @update="reachedSchutzziel2 = $event"
            )

            tab-download(v-if="tabAvailable(5)", :class="tabActive(5)", v-model="protocol")
</template>

<script>
import api from '@/utils/api'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCube, faSquareRootAlt, faCheckCircle, faExclamationCircle, faFileExport } from '@fortawesome/free-solid-svg-icons'
import { Protocol } from 'trgi'

import TabMetadata from './Tabs/0_Metadata'
import TabBaseValues from './Tabs/1_BaseValues'
import TabRooms from './Tabs/2_Rooms'
import TabSchutzziel1 from './Tabs/3_Schutzziel1'
import TabSchutzziel2 from './Tabs/4_Schutzziel2'
import TabDownload from './Tabs/5_Download'

library.add(faCube, faSquareRootAlt, faCheckCircle, faExclamationCircle, faFileExport)

export default {
    components: {
        TabMetadata,
        TabBaseValues,
        TabRooms,
        TabSchutzziel1,
        TabSchutzziel2,
        TabDownload
    },
    data () {
        return {
            activeTab: 0,
            protocol: new Protocol(),
            reachedSchutzziel1: false,
            reachedSchutzziel2: false
        }
    },
    computed: {
        // TODO: we must find another solution
        requireSchutzziel1 () {
            if (this.protocol.data.rooms.length >= 1 && this.protocol.data.rooms[0].fireplaces.length) {
                // let fClass = this.protocol.data.rooms[0].fireplaces[0].class
                // if (fClass.startsWith('B1') || fClass.startsWith('B4')) {
                return true
                // }
            }
            return false
        }
    },
    created () {
        if (this.$route.query.id) {
            this.loadProtocol(this.$route.query.id)
        }
    },
    methods: {
        tabAvailable (tab) {
            // All Tabs - except the first one - need an existing protocol
            if (tab !== 0 && !this.protocol.id) {
                return false
            }

            // Schutzziel 1 & 2 Tabs need at least one room, a fireplace and BaseValues defined
            if (tab === 3 || tab === 4) {
                if (this.protocol.data.multistory === undefined) {
                    return false
                }
                if (!this.protocol.data.rooms.length || !this.protocol.data.rooms[0].fireplaces.length) {
                    return false
                }
            }

            // FIXME: Should the PDF-Download be able before Schutzziel 1 & 2 are reached?
            if (tab === 5 && !this.reachedSchutzziel2) {
                return false
            }

            return true
        },
        tabActive (tab) {
            return {
                active: this.activeTab === tab
            }
        },
        async createProtocol (data) {
            try {
                const protocol = await api.post('/protocols', data).then(res => res.data)
                this.$router.push(`/protokolle/erstellen?id=${protocol.id}`)
                await this.loadProtocol(protocol.id)
                this.activeTab++
            } catch (err) {
                this.$store.dispatch('alert/error', `Protokoll konnte nicht erstellt werden (${err.message})`)
            }
        },
        async loadProtocol (id) {
            try {
                this.protocol = await api.get(`/protocols/${id}`).then(res => new Protocol(res.data))
            } catch (err) {
                this.$router.push('/protokolle')
            }
        },
        async saveAndContinue (data) {
            // create a new protocol, if we have no id yet
            if (!this.protocol.id) {
                return this.createProtocol(data)
            }

            // when an already closed protocol gets modified, it's open again
            this.protocol.status = 'open'

            this.protocol = await api.post(`/protocols/${this.protocol.id}`, data).then(res => new Protocol(res.data))

            if (this.tabAvailable(this.activeTab + 1)) {
                this.activeTab++
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    margin-top: 3rem;

    .card-header .nav-link {
        cursor: pointer;
        padding: 0.5rem 0.65rem !important;
    }

    .tab-pane .form-group {
        margin: 1rem 0 3rem;
    }
}
</style>
